/** Lead status from list or member row (`lead_status` from POST /leads / summary). */
export function getLeadStatus(row) {
    return String(row?.lead_status ?? row?.leadStatus ?? "").trim();
}

/** Map API lead status label to tone (CSS modifier). */
export function getLeadStatusTone(label) {
    const normalized = String(label || "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, " ");
    if (!normalized) {
        return "";
    }
    if (normalized === "pending outreach") {
        return "pending-outreach";
    }
    if (normalized === "closed") {
        return "closed";
    }
    if (normalized === "declined") {
        return "declined";
    }
    if (normalized === "new") {
        return "new";
    }
    if (normalized === "currently in outreach") {
        return "currently-in-outreach";
    }
    return "";
}

/** Display label + tone for Lead Status (list + detail). */
export function getLeadStatusDisplay(row) {
    const label = getLeadStatus(row);
    if (!label) {
        return { label: "", tone: "" };
    }
    return { label, tone: getLeadStatusTone(label) };
}
